import Vue from 'vue'
import Framework7 from 'framework7/framework7.esm.bundle.js'
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'
import injector from 'vue-inject'
// import 'framework7/css/framework7.min.css'
import 'framework7/css/framework7.md.min.css'
import './css/icons.css'
import './css/dialog.css'
import './bindings'
import './font-awesome'
import store from './store'
import VueMoment from 'vue-moment'
import App from './App'
import './registerServiceWorker'
import i18n from './i18n'

Vue.config.productionTip = false
Vue.config.silent = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development'
if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
}

Framework7.use(Framework7Vue)
Vue.use(injector)
Vue.use(VueMoment)

window.onbeforeunload = function (e) {
  return '確定重新載入或是離開此網頁?'
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  components: { App },
  template: '<App/>'
})
